import React, { useState, useEffect } from "react";
import Anchor from "../../Asset/icon/anchor.svg";
import compass from "../../Asset/icon/compass.svg";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getDestinationDetail } from "../../redux/centerData/CenterDataSlice";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Tooltip,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import "../../Asset/scss/takemyyacht.scss";

const PackagesCard = ({
  name,
  islands,
  price,
  dayOption,
  slug,
  vat,
  originalPrice,
  discountType,
  discountValue,
  promotionCode,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const todos = useSelector((state) => state);

  const [loading, setLoading] = useState(true);
  const formattedPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  useEffect(() => {
    Promise.all([dispatch(getDestinationDetail({}))])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const mapDay = (dayOption) => {
    switch (dayOption) {
      case "DayTrip":
        return t("Full Day");
      case "HalfDay":
        return t("Half Day");
      case "Overnight":
        return t("Overnight");
      default:
        return dayOption;
    }
  };

  const translatedDay = mapDay(dayOption);

  return (
    <div className="package-box-shadow">
      <div className="row align-items-stretch mb-4 p-3">
        {/* ซ้าย */}
        <div className="col-12 col-md-5 mb-3 mb-md-0">
          <div className="d-flex">
            <img src={Anchor} draggable={false} />
            <p className="m-0 p-2">{name}</p>
          </div>

          {islands.includes(",") ? (
            islands.split(",").map((item, index) => (
              <ul className="d-flex" key={index}>
                <img src={compass} draggable={false} alt="compassImage" />
                <li className="m-0 p-2">{item.trim()}</li>
              </ul>
            ))
          ) : (
            <ul className="d-flex">
              <img src={compass} draggable={false} alt="compassImage" />
              <li className="m-0 p-2">{islands}</li>
            </ul>
          )}
        </div>

        {/* ตรงกลาง */}
        <div className="col-12 col-md-2 d-flex align-items-center justify-content-center mb-3 mb-md-0">
          <img src={compass} draggable={false} alt="compassImage" />
        </div>

        {/* ขวา */}
        <div className="col-12 col-md-5 d-flex flex-column align-items-end justify-content-between">
          <h4 className="text-danger mb-0 package-margin">{translatedDay}</h4>
          <div className="d-flex flex-column align-items-end">
            <div className="flex-package">
              <Typography
                variant="body1"
                color="textPrimary"
                className="package-margin"
              >
                THB
              </Typography>
              &nbsp;
              <Typography variant="h5" className="package-style">
                {formattedPrice}
              </Typography>
            </div>
            <div>
              {vat ? (
                <Tooltip title={t("This price is subject to VAT")}>
                  <Typography
                    className="start-from vat-text cursor-help"
                  >
                    *&nbsp;{t("This price is subject to VAT")}
                  </Typography>
                </Tooltip>
              ) : null}
            </div>
            <div className="d-flex align-items-end content mb-0 negative-package-margin">
              <Link
                to={`/bookingInquiry/${slug}?price=${price}&originalPrice=${originalPrice}&discountType=${discountType}&discountValue=${discountValue}&promotionCode=${promotionCode}`}
                className="btn btn-primary"
                id="buttonBooking"
              >
                {t("Booking Inquiry")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackagesCard;
